////////LIBRARY/////////
import styled from 'styled-components'
import { Link } from 'react-router-dom'
/////////ASSETS/////////
import ResetFormIcon from '../assets/icones/global/reset-white.svg'
import PrevPageIcon from '../assets/icones/global/close-white.svg'
import ValidateFormIcon from '../assets/icones/global/check.svg'
import AddButton from '../assets/icones/global/add.svg'
import SelectDropdownWhiteIcon from '../assets/icones/global/select-dropdown-white.svg'
import SelectDropdownDefaultIcon from '../assets/icones/global/select-dropdown-black.svg'
import SearchIcon from '../assets/icones/global/zoom-in.svg'
import ResetSearchIcon from '../assets/icones/global/close-red.svg'
import BackArrowIcon from '../assets/icones/global/back-arrow.svg'
import Eraser from '../assets/icones/globalCss/eraser.svg'
import Trash from '../assets/icones/global/trash-white.svg'
import Download from '../assets/icones/globalCss/download.svg'
import Save from '../assets/icones/global/save.svg'

///////////////////////////////////////////////////////////////
// LAYOUT        START
///////////////////////////////////////////////////////////////
export const PageWrapper = styled.div`
	position: relative;
`
export const PageTitle = styled.p`
	color: ${(props) => props.theme.colors.primary};
	font-weight: bold;
`

export const SpanTitle = styled.span`
	color: ${(props) => props.theme.colors.primary};
	font-weight: bold;
`

export const PageWrapperPartHandler = styled.div`
	display: grid;
	grid-template-columns: repeat(4, minmax(min-content, 1fr));
	justify-content: flex-start;
`
export const PageWrapperPart = styled.div`
	padding: 0px 20px;
	border-right: 1px solid #e5e5e5;
	:first-child {
		padding-left: 0px;
	}
	:last-child {
		padding-right: 0px;
		border-right: none;
	}
`
export const PageWrapperLinks = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: stretch;
	align-content: stretch;
	justify-content: stretch;
	flex-direction: row-reverse;
	flex-basis: max-content;
	position: absolute;
	& > * {
		margin: 0px 8px;
		height: 32px !important;
		transition: background-color 0.1s;
	}
	& > :first-child {
		margin-left: 0px;
	}
	& > :hover {
		background-color: ${(props) => props.theme.colors.wedealBlueOther};
	}
	top: -90px;
	left: -20px;
`

export const PageWrapperSecondaryLinks = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: stretch;
	align-content: stretch;
	justify-content: stretch;
	flex-direction: row-reverse;
	flex-basis: max-content;
	position: absolute;
	& > * {
		margin: 0px 8px;
		height: 32px !important;
		transition: background-color 0.1s;
	}
	& > :first-child {
		margin-left: 0px;
	}
	& > :hover {
		background-color: ${(props) => props.theme.colors.wedealBlueOther};
	}
	top: -70px;
	right: 0px;
`

export const PageWrapperGrids = styled.div`
	display: grid;
	position: relative;
	grid-template-columns: repeat(${(props) => props.grids}, 1fr);
	grid-column-gap: 20px;
	align-items: start;
	box-sizing: border-box;
`
export const PageGrid = styled.div`
	position: relative;
`

export const PageGridTitle = styled.p`
	padding: 11px 0px 11px 15px;
	color: ${(props) => props.theme.colors.primary};
	font-size: ${(props) => props.theme.font.fs};
	display: block;
	margin: 0;
	font-weight: bold;
`
export const PageGridBorder = styled.div`
	border: 1px solid ${(props) => props.theme.colors.listNav.border};
	border-radius: 4px;
`

export const CreateButton = styled.div`
	width: 32px;
	height: 32px;
	border-radius: 16px;
	background-color: ${(props) => props.theme.colors.primary};
	background-image: url(${AddButton});
	background-repeat: no-repeat;
	background-position: center;
	cursor: pointer;
	margin-right: 0px;
	margin-left: auto;
	:hover {
		background-color: ${(props) => props.theme.colors.hoverPrimary};
	}
	transition: background-color 0.1s;
`

export const TableHeaderCreateButton = styled(Link)`
	width: 32px;
	height: 32px;
	border-radius: 16px;
	background-color: ${(props) => props.theme.colors.primary};
	background-image: url(${AddButton});
	background-repeat: no-repeat;
	background-position: center;
	position: absolute;
	right: 0;
	top: -63px;
	cursor: pointer;
	:hover {
		background-color: ${(props) => props.theme.colors.wedealBlueOther};
	}
	transition: background-color 0.1s;
`
export const PageWrapperActions = styled.div`
	display: flex;
	flex-direction: row-reverse;
	position: ${(props) => (props.absolute ? 'absolute' : 'relative')};
	right: 0px;
	top: ${(props) => (props.absolute && props.outFramed ? (props.withPageLinks ? '-90px' : '-67px') : '-7px')};
`

export const ActionWrapper = styled.div`
	display: inline-flex;
	flex-wrap: wrap;
	align-items: stretch;
	align-content: stretch;
	justify-content: stretch;
	flex-direction: row-reverse;
	flex-basis: max-content;
`
export const ActionWrapperElem = styled.div`
	display: flex;
	width: ${(props) => (props.closed ? '100%' : '')};
	justify-content: 'stretch';
	align-items: center;
	height: 32px;
	margin: 8px;
	font-size: ${(props) => props.theme.font.fs};
`
export const TableActionsWrapper = styled(ActionWrapper)`
	position: absolute;
	top: -72px;
	right: 37px;
`
export const PageWrapperActionReset = styled.div`
	background-color: ${(props) => props.theme.colors.form.reload};
	background-image: url('${ResetFormIcon}');
	border-radius: 4px;
	width: 32px;
	height: 32px;
	cursor: pointer;
	background-repeat: no-repeat;
	background-position: center;
	margin: 0px 5px;
	border: none;
	:hover {
		background-color: ${(props) => props.theme.colors.hoverGrey};
	}
	transition: background-color 0.1s;
`
export const PageWrapperActionPrevPage = styled.div`
	background-color: ${(props) => props.theme.colors.error};
	background-image: url('${PrevPageIcon}');
	border-radius: 4px;
	width: 32px;
	height: 32px;
	cursor: pointer;
	background-repeat: no-repeat;
	background-position: center;
	margin: 0px 5px;
	border: none;
	:hover {
		background-color: ${(props) => props.theme.colors.hoverError};
	}
	transition: background-color 0.1s;
`
export const PageWrapperActionValidate = styled.button`
	background-color: ${(props) => props.theme.colors.form.validate};
	background-image: url('${ValidateFormIcon}');
	border-radius: 4px;
	width: 32px;
	height: 32px;
	cursor: ${(props) => (typeof props.unlocked === 'undefined' || props.unlocked ? 'pointer' : 'not-allowed')};
	background-repeat: no-repeat;
	background-position: center;
	margin: 0px 5px;
	border: none;
	filter: ${(props) => (typeof props.unlocked === 'undefined' || props.unlocked ? 'grayscale(0)' : 'grayscale(1)')};
	transition: all 0.1s;
	font-family: 'Lato', sans-serif;
	:hover {
		background-color: ${(props) => props.theme.colors.hoverValidation};
	}
	transition: background-color 0.1s;
`

export const PageWrapperActionErase = styled.button`
	background-color: ${(props) => props.theme.colors.eraser};
	background-image: url('${Eraser}');
	border-radius: 4px;
	width: 32px;
	height: 32px;
	cursor: pointer;
	background-repeat: no-repeat;
	background-position: center;
	margin: 0px 5px;
	border: none;
	font-family: 'Lato', sans-serif;
`

export const PageWrapperActionTrash = styled.button`
	background-color: ${(props) => props.theme.colors.error};
	background-image: url('${Trash}');
	border-radius: 4px;
	width: 32px;
	height: 32px;
	/*cursor:${(props) => (typeof props.unlocked === 'undefined' || props.unlocked ? 'pointer' : 'initial')};*/
	cursor: ${(props) => (!props.disabled ? 'pointer' : 'not-allowed')};
	/*filter:${(props) => (typeof props.unlocked === 'undefined' || props.unlocked ? 'grayscale(0)' : 'grayscale(1)')};*/
	background-repeat: no-repeat;
	background-position: center;
	margin: 0px 5px;
	border: none;
	font-family: 'Lato', sans-serif;
	:hover {
		background-color: ${(props) => (!props.disabled ? props.theme.colors.hoverError : props.theme.colors.hoverGrey)};
	}
	transition: background-color 0.1s;
`

export const PageWrapperActionSave = styled.button`
	background-color: ${(props) => (!props.disabled ? props.theme.colors.primary : props.theme.colors.eraser)};
	background-image: url('${Save}');
	border-radius: 4px;
	width: 32px;
	height: 32px;
	/*cursor:${(props) => (typeof props.unlocked === 'undefined' || props.unlocked ? 'pointer' : 'initial')};*/
	cursor: ${(props) => (!props.disabled ? 'pointer' : 'not-allowed')};
	/*filter:${(props) => (typeof props.unlocked === 'undefined' || props.unlocked ? 'grayscale(0)' : 'grayscale(1)')};*/
	background-repeat: no-repeat;
	background-position: center;
	margin: 0px 5px;
	border: none;
	font-family: 'Lato', sans-serif;
	:hover {
		background-color: ${(props) => (!props.disabled ? props.theme.colors.hoverPrimary : props.theme.colors.hoverGrey)};
	}
	transition: background-color 0.1s;
`

export const ToggleShortcutWrapper = styled.div`
	display: grid;
	grid-column-gap: 15px;
	justify-items: ${(props) => (props.justifyItems ? props.justifyItems : 'center')};
	align-items: center;
	grid-template-columns: auto auto;
	margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : null)};
`

export const ShiftItemButton = styled.div`
	background: ${(props) => (props.active ? props.theme.colors.primary : props.theme.colors.form.reset)} padding-box;
	border-radius: 4px 25px 25px 4px !important;
	line-height: 50px;
	color: ${(props) => props.theme.colors.white};
	text-align: center;
	font-size: ${(props) => props.theme.font.fs};
	margin: 15px;
	cursor: ${(props) => (props.active ? 'pointer' : 'not-allowed')};
	position: relative;
	:hover {
		background-color: ${(props) => (props.active ? props.theme.colors.wedealBlueOther : props.theme.colors.form.reset)};
	}
	transition: all 0.1s;
	:after {
		content: '';
		background-image: ${(props) => (props.modalMode ? 'none' : `url('${BackArrowIcon}')`)};
		background-repeat: no-repeat;
		position: absolute;
		width: 9px;
		height: 17px;
		right: 20px;
		transform: scaleX(-1) translateY(-50%);
		top: 50%;
		background-size: 100% 100%;
	}
`

export const ReverseShiftItemButton = styled.div`
	background: ${(props) => (props.active ? props.theme.colors.primary : props.theme.colors.form.reset)} padding-box;
	border-radius: 25px 4px 4px 25px !important;
	line-height: 50px;
	color: ${(props) => props.theme.colors.white};
	text-align: center;
	margin: 15px;
	cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
	position: relative;
	font-size: ${(props) => props.theme.font.fs};
	:hover {
		background-color: ${(props) => (props.active ? props.theme.colors.wedealBlueOther : props.theme.colors.form.reset)};
	}
	transition: all 0.1s;
	:before {
		content: '';
		background-image: ${(props) => (props.modalMode ? 'none' : `url('${BackArrowIcon}')`)};
		background-repeat: no-repeat;
		position: absolute;
		width: 9px;
		height: 17px;
		left: 20px;
		transform: translateY(-50%);
		top: 50%;
		background-size: 100% 100%;
	}
`

export const HeaderFilters = styled.div`
	display: grid;
	grid-template-rows: 1fr 1fr;
	grid-row-gap: 10px;
	border-bottom: 1px solid ${(props) => props.theme.colors.TabNav.border};
	padding: 10px;
`
export const HeaderFiltersLine = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-column-gap: 10px;
	align-items: center;
	& :first-child {
		justify-content: flex-start;
	}
	& :last-child {
		justify-content: flex-end;
	}
`
export const ResultKioskNumber = styled.p`
	text-overflow: ellipsis;
	margin: 0;
`
export const NumberPerimeter = styled.span`
	margin: 0 5px 0 0;
	color: ${(props) => props.theme.colors.primary};
	font-weight: bold;
`
export const TextPerimeter = styled.span`
	margin: 0;
	color: ${(props) => props.theme.colors.eraser};
`
export const ToggleWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`
export const ContentToggles = styled.div`
	display: grid;
	grid-template-columns: max-content max-content;
	grid-column-gap: 30px;
`

///////////////////////////////////////////////////////////////
// LAYOUT        END
///////////////////////////////////////////////////////////////

///////////////////////////////////////////////////////////////
// FORMS        START
///////////////////////////////////////////////////////////////

export const FormInfoWrapper = styled.div`
	position: relative;
	display: grid;
	grid-template-columns: max-content 208px;
	grid-column-gap: 20px;
	grid-row-gap: 20px;
	align-items: center;
	color: ${(props) => props.theme.colors.menu.link};
	box-sizing: border-box;
`

export const UserWrapperForm = styled.form`
	display: grid;
	grid-template-columns: max-content max-content;
	grid-auto-rows: max-content;
	grid-column-gap: 144px;
`

export const InputWrapper = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	margin-bottom: ${(props) => (props.margin ? `${props.margin}px` : null)};
`

export const ControllerFileWrapper = styled(InputWrapper)`
	& > input {
		width: 0.1px;
		height: 0.1px;
		opacity: 0;
		overflow: hidden;
		position: absolute;
		z-index: -1;
	}
	& > span {
		font-style: italic;
		font-size: 12px;
		margin-top: 3px;
	}
`

export const KioskCheckBoxWrapper = styled.div`
	display: grid;
	grid-template-columns: max-content;
	grid-row-gap: 10px;
	input {
		width: 17px;
		height: 17px;
		padding: 0;
		margin: 0;
	}
`
export const LabelCheckbox = styled.label`
	display: grid;
	grid-template-columns: min-content max-content;
	grid-column-gap: 5px;
	align-content: center;
`
export const InputLogin = styled.input`
	height: 32px;
	width: ${(props) => (props.width ? `${props.width}px` : '208px')};
	border-radius: 3px;
	border: ${(props) =>
		props.touched
			? props.validated
				? `1px solid ${props.theme.colors.validation}`
				: `1px solid ${props.theme.colors.error}`
			: `1px solid ${props.theme.colors.input.border}`};
	box-sizing: border-box;
	font-size: 13px;
	padding-left: 13px;
	/*padding-top:2px;*/
	color: ${(props) => props.theme.colors.menu.link};
	background-color: ${(props) => (props.disabled ? props.theme.colors.whiteGrey : props.theme.colors.white)};
	:focus {
		outline: none !important;
		border-color: ${(props) => props.theme.colors.primary};
	}
	:-webkit-autofill,
	:-webkit-autofill:hover,
	:-webkit-autofill:focus,
	:-webkit-autofill:active {
		transition: background-color 5000s ease-in-out 0s;
		box-shadow: 0 0 0px 1000px ${(props) => props.theme.colors.white} inset;
	}
	&::placeholder {
		color: ${(props) => props.theme.colors.eraser};
		opacity: 1;
	}
`

export const TextareaStyled = styled.textarea`
	border-radius: 3px;
	border: ${(props) =>
		props.touched
			? props.validated
				? `1px solid ${props.theme.colors.validation}`
				: `1px solid ${props.theme.colors.error}`
			: `1px solid ${props.theme.colors.input.border}`};
	box-sizing: border-box;
	font-size: 13px;
	padding: 10px;
	color: ${(props) => props.theme.colors.menu.link};
	background-color: ${(props) => (props.disabled ? props.theme.colors.whiteGrey : props.theme.colors.white)};
	:focus {
		outline: none !important;
		border-color: ${(props) => props.theme.colors.primary};
	}
	:-webkit-autofill,
	:-webkit-autofill:hover,
	:-webkit-autofill:focus,
	:-webkit-autofill:active {
		transition: background-color 5000s ease-in-out 0s;
		box-shadow: 0 0 0px 1000px ${(props) => props.theme.colors.white} inset;
	}
	height: 100%;
`

export const SearchInputWrapper = styled.div`
	width: 222px;
	position: relative;
`

export const SearchInputButton = styled.div`
	width: 32px;
	height: 32px;
	background-color: ${(props) => props.theme.colors.primary};
	border-radius: 0px 3px 3px 0px;
	right: 0px;
	top: 0px;
	background-image: url('${SearchIcon}');
	background-repeat: no-repeat;
	background-position: center;
	position: absolute;
	cursor: pointer;
	:hover {
		background-color: ${(props) => props.theme.colors.hoverPrimary};
	}
	transition: background-color 0.1s;
`
export const SearchReset = styled.div`
	background-image: url('${ResetSearchIcon}');
	background-repeat: no-repeat;
	background-position: center;
	margin: 11px;
	cursor: pointer;
	width: 10px;
	height: 10px;
`

export const RadioElementWrapper = styled.div`
	display: grid;
	grid-template-columns: 85px 85px;
	justify-items: flex-start;
	grid-column-gap: 17px;
	align-items: center;
`

export const RadioItem = styled.div`
	display: flex;
	width: 100%;
	position: relative;
`

export const RadioInput = styled.span`
	position: absolute;
	cursor: pointer;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: ${(props) => props.theme.colors.white};
	border-radius: 50%;
	border: 1px solid ${(props) => props.theme.colors.borderList};
	::before {
		position: absolute;
		content: '';
		height: 9px;
		width: 9px;
		left: 3px;
		bottom: 3px;
		display: none;
		background-color: ${(props) => props.theme.colors.menu.link};
		border-radius: 50%;
	}
`
export const RadioButtonLabel = styled.label`
	display: flex;
	position: relative;
	width: 17px;
	height: 17px;
`
// DIFF
export const TextLabel = styled.p`
	margin: 0 0 0 17px;
	padding: 0;
	text-decoration: ${(props) => (props.disabled ? 'line-through' : 'inherit')};
`
export const RadioCustom = styled.input`
	opacity: 0;
	width: 0;
	height: 0;
	:checked + ${RadioInput} {
		background-color: ${(props) => props.theme.colors.white};
	}
	:focus + ${RadioInput} {
		box-shadow: 0 0 1px ${(props) => props.theme.colors.primary};
	}
	:checked + ${RadioInput}:before {
		display: flex;
	}
`

export const SelectFlexWrapper = styled.div`
	display: flex;
`

export const SelectInputWrapper = styled.div`
	width: ${(props) => (props.width ? `${props.width}px` : 'min-content')};
	&::after {
		content: '';
		width: 32px;
		height: ${(props) => (props.heightAfter ? `${props.heightAfter}%` : ' 100%')};
		background-color: ${(props) => {
			if (props.eraserColor) {
				return props.theme.colors.eraser
			} else if (props.blueColor) {
				return props.theme.colors.primary
			} else {
				return props.theme.colors.dropdownDefault
			}
		}};
		pointer-events: none;
		position: absolute;
		border-radius: ${(props) => (props.reverseMode ? '3px 0px 0px 3px' : '0px 3px 3px 0px')};
		right: ${(props) => (props.reverseMode ? 'unset' : '0px')};
		left: ${(props) => (props.reverseMode ? '0px' : 'unset')};
		background-image: ${(props) =>
			props.blueColor || props.eraserColor ? `url('${SelectDropdownWhiteIcon}')` : `url('${SelectDropdownDefaultIcon}')`};
		background-repeat: no-repeat;
		background-position: center;
		transition: background-color 0.1s;
	}
	position: relative;
	display: flex;
	align-items: ${(props) => (props.alignItems ? props.alignItems : null)};
	:hover::after {
		background-color: ${(props) => (props.blueColor ? props.theme.colors.wedealBlueOther : props.theme.colors.dropdownDefault)};
	}
	& .active {
		color: ${(props) => props.theme.text.colors.primary};
	}
`
export const SelectInput = styled.select`
	height: 32px;
	width: ${(props) => (props.width ? `${props.width}px` : 'min-content')};
	border-radius: 3px;
	border: 1px solid ${(props) => props.theme.colors.dropdownDefault};
	box-sizing: border-box;
	font-size: 13px;
	padding-left: ${(props) => (props.reverseMode ? '45px' : '13px')};
	padding-right: ${(props) => (props.reverseMode ? '13px' : '45px')};
	color: ${(props) => props.theme.colors.menu.link};
	background-color: ${(props) => props.theme.colors.white};
	&:focus {
		outline: none !important;
		border-color: ${(props) => props.theme.colors.menu.primary};
	}
	-webkit-appearance: none;
`

export const LabelFile = styled.label`
	height: 32px;
	width: ${(props) => (props.width ? `${props.width}px` : 'min-content')};
	border-radius: 3px;
	border: 1px solid ${(props) => props.theme.colors.dropdownDefault};
	box-sizing: border-box;
	font-size: 13px;
	padding-left: ${(props) => (props.reverseMode ? '63px' : '13px')};
	padding-right: ${(props) => (props.reverseMode ? '13px' : '63px')};
	color: ${(props) => props.theme.colors.menu.link};
	background-color: ${(props) => props.theme.colors.white};
	&:focus {
		outline: none !important;
		border-color: ${(props) => props.theme.colors.menu.primary};
	}
	-webkit-appearance: none;
	line-height: 32px;
	&:after {
		content: '';
		background-image: url(${Download});
		position: absolute;
		right: ${(props) => (props.reverseMode ? 'unset' : '0px')};
		height: 32px;
		width: 50px;
		background-color: ${(props) => props.theme.colors.primary};
		background-repeat: no-repeat;
		background-position: center;
		border-radius: ${(props) => (props.reverseMode ? '4px 0px 0px 4px;' : '0px 4px 4px 0px;')};
		top: 0px;
		cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
	}
`

export const LabelFileCustom = styled(LabelFile)`
	color: ${(props) => props.theme.colors.eraser};
`

export const ErrorInputFlex = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	& > div {
		text-align: center;
	}
`

export const ErrorInputMsg = styled.div`
	color: ${(props) => props.theme.colors.error};
`
export const ErrorFormMsg = styled.div`
	position: absolute;
	top: -40px;
	width: 240px;
	text-align: center;
	justify-self: center;
	color: ${(props) => props.theme.colors.error};
`
export const LabelText = styled.div`
	margin: 0;
	font-weight: bold;
	font-size: 13px;
	color: ${(props) => props.theme.colors.menu.link};
`
export const LabelTextKiosks = styled.p`
	margin: 0;
	font-weight: bold;
	font-size: 13px;
	color: ${(props) => props.theme.colors.menu.link};
	align-self: flex-start;
`

export const OptionCustom = styled.option`
	color: ${(props) => props.target && props.theme.text.colors.primary};
`

export const SelectInputCustom = styled(SelectInput)`
	color: ${(props) => (props.placeholder ? props.placeholder : props.theme.colors.eraser)};
	cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
`
///////////////////////////////////////////////////////////////
// FORMS        END
///////////////////////////////////////////////////////////////

///////////////////////////////////////////////////////////////
// MODALS        START
///////////////////////////////////////////////////////////////

export const TextModal = styled.div`
	margin: 0;
	padding: ${(props) => (props.padding ? `${props.padding}px 0` : '15px 0 ')};
	font-size: 14px;
	color: ${(props) => (props.color ? props.color : null)};
	text-decoration: ${(props) => (props.underline ? 'underline' : null)};
	text-align: ${(props) => (props.align ? props.align : null)};
`

export const ButtonWrapper = styled.div`
	display: flex;
	height: 32px;
	width: 100%;
	justify-content: ${(props) => (props.singleButton ? 'center' : 'space-between')};
	font-size: 13px;
	margin: 0px;
`

export const TextModalList = styled.div`
	display: grid;
	grid-template-columns: max-content max-content;
	grid-column-gap: 15px;
	grid-row-gap: 15px;
`

///////////////////////////////////////////////////////////////
// MODALS        END
///////////////////////////////////////////////////////////////

///////////////////////////////////////////////////////////////
// TABLE        START
///////////////////////////////////////////////////////////////

export const TableWrapper = styled.div`
	/* position: relative; */
`

export const TableContent = styled.table`
	border-spacing: 0;
	box-sizing: border-box;
	min-width: 100%;
	width: max-content;
	position: relative;
`

export const TableHeaderWrapper = styled.thead`
	background-color: ${(props) => props.theme.colors.table.header.main};
	position: relative;
	top: ${(props) => `-${props.topped}px`};
`

export const HeaderCells = styled.th`
	text-align: center;
	background-color: ${(props) => (props.nestedTheme ? props.theme.colors.table.nested.header : props.theme.colors.table.header.main)};
	font-weight: bold;
	color: ${(props) => (props.nestedTheme ? props.theme.colors.white : props.theme.colors.table.header.text)};
	height: 45px;
	cursor: pointer;
	position: sticky;
	line-height: 30px;
	top: 0px;
	z-index: 4;
	box-sizing: border-box;
	padding: 12px 10px 10px;
`

export const HeaderCellsSticky = styled(HeaderCells)`
	background-color: ${(props) => (props.nestedTheme ? props.theme.colors.table.nested.header : props.theme.colors.table.header.main)};
	right: 0;
	z-index: 5;
	width: ${(props) => (props.hasActionIconsDisplay ? '140px' : '27px')};
	border-left: ${(props) => (!props.nestedTheme ? `1px solid ${props.theme.colors.TabNav.border}` : 'none')};
`

export const TableBodyWrapper = styled.tbody`
	color: ${(props) => props.theme.colors.table.body.text};
	background-color: ${(props) => props.theme.colors.white};
	border-right: 1px solid ${(props) => props.theme.colors.table.borderActionTable};
`

export const TableLineWrapper = styled.tr`
	background-color: ${(props) => (props.error ? props.theme.colors.errorlight : props.theme.colors.table.line)};
	:hover {
		background-color: rgba(0, 0, 0, 0.02);
	}
	transition: background-color 0.1s;
`

export const BodyCells = styled.td`
	display: table-cell;
	text-align: center;
	background-color: 'inherit';
	height: 50px;
	box-sizing: border-box;
	padding: 5px 5px;
	border-top: 1px solid ${(props) => props.theme.colors.table.borderTable};
`

export const BodyCellsSticky = styled(BodyCells)`
	position: sticky;
	background-color: ${(props) => props.theme.colors.white};
	right: 0;
	z-index: ${(props) => (props.toggledAction ? 50 : 4)};
	border-left: 1px solid ${(props) => props.theme.colors.table.borderTable};
`

export const BodyCellsToggler = styled(BodyCells)`
	cursor: ${(props) => (props.canToggle ? 'pointer' : 'inherit')};
`

export const ToggleNestedIconWrapper = styled.div`
	text-align: center;
	cursor: pointer;
`

export const ToggleNestedIcon = styled.img`
	transform: ${(props) => (props.dropped ? 'rotate(180deg)' : 'rotate(0deg)')};
`

export const SkeletonActionWrapper = styled.div`
	width: 22px;
	height: 22px;
	display: inline-block;
	margin: 0px 5px;
	line-height: normal;
	& > span {
		height: 100%;
		line-height: normal;
	}
`

///////////////////////////////////////////////////////////////
// TABLE        END
///////////////////////////////////////////////////////////////

export const DatePickerFilterLabel = styled.div`
	margin-left: 10px;
	& span {
		display: block;
	}
`
